<div class="col p-0 m-0">
    <carousel class="home-carousel" #carousel (mouseenter)="setPause()" (mouseleave)="setPlay()" (mouseup)="setPause()" (mouseenter)="setPause()"
        (mouseleave)="setPlay()" (mouseup)="setPause()" [noPause]="false" [showIndicators]="showIndicator" [interval]="carouselInterval"
        [(activeSlide)]="activeSlideIndex">
        <slide *ngFor="let slide of homeImages; let index=index">
            <img [src]="slide" alt="first slide" id="{{appName}}-{{featureType === 'internal' ? 'internal' : 'external'}}-{{index+1}}">
            <div class="carousel-numbers-wrapper">
                <span class="index">{{index+1}}</span> of
                <span class="length">{{homeImages.length}}</span>
            </div>
        </slide>
    </carousel>
</div>